import {
  LinkListItem,
  MediaItem,
  NestedBlock,
} from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import React from 'react'
import { ListLayout as LinkListListLayout } from '../../linkListBlock/linkListBlock'
// import { ItemLayout as MediaItemLayout } from '../../mediaBlock/mediaBlock'
import { QuoteLayout } from '../../quoteBlock/quoteBlock'

export const NestedBlocks = (props: {
  nestedBlocks: Array<NestedBlock>
  videoCookieAccepted: boolean
  acceptVideoCookie: () => void
}) => {
  const { nestedBlocks, videoCookieAccepted, acceptVideoCookie, } = props

  return nestedBlocks.map((block, i) => {
    switch (block.kind) {
      case 'nestedTextBlock':
        return <NestedTextBlockLayout key={i} {...block} />
      case 'nestedQuoteBlock':
        return <NestedQuoteBlockLayout key={i} {...block} />
      // case 'video':
      // case 'image':
      //   return (
      //     <NestedMediaBlockLayout
      //       key={i}
      //       videoCookieAccepted={videoCookieAccepted}
      //       acceptVideoCookie={acceptVideoCookie}
      //       {...block}
      //     />
      //   )
      case 'nestedLinkListBlock':
        return <NestedLinkListBlockLayout key={i} {...block} />
    }
  })
}

const NestedLinkListBlockLayout = ({ items }: { items: LinkListItem[] }) => (
  <section className="block-nested block-nested--linklist">
    <div className="block-nested__inner">
      <LinkListListLayout items={items} />
    </div>
  </section>
)

// const NestedMediaBlockLayout = (
//   props: MediaItem & {
//     videoCookieAccepted: boolean
//     acceptVideoCookie: () => void
//   }
// ) => (
//   <section className="block-nested block-nested--media">
//     <div className="block-nested__inner">
//       <MediaItemLayout {...props} displayOption="content-width" />
//     </div>
//   </section>
// )

const NestedQuoteBlockLayout = (props: { text: string; author?: string; authorDescription?: string }) => (
  <section className="block-nested block-nested--quote">
    <div className="block-nested__inner">
      <QuoteLayout {...props} />
    </div>
  </section>
)

const NestedTextBlockLayout = ({ body }: { body?: string }) =>
  body ? (
    <div className="block-nested block-nested--text">
      <div className="block__nested-inner">
        <div className="text--styled" dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </div>
  ) : (
    <></>
  )
